import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Pen = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1311 2.54528C10.8345 1.81726 12.0017 1.81839 12.7037 2.54776L13.4754 3.34955C14.1612 4.06216 14.1378 5.19635 13.4231 5.88L12.5349 6.72955L6.30852 12.9833L2.90984 13.9717C2.3933 14.1219 1.9108 13.6502 2.04924 13.1304L2.98628 9.612L9.26297 3.44383L10.1311 2.54528ZM9.68154 4.70272L4.36115 9.93112L5.99863 11.6062L11.2772 6.3043L9.68154 4.70272ZM12.1279 5.47031L12.5996 5.01913C12.8379 4.79125 12.8457 4.41319 12.6171 4.17565L11.8454 3.37386C11.6114 3.13074 11.2223 3.13036 10.9879 3.37303L10.5204 3.85685L12.1279 5.47031ZM4.874 12.1599L3.82602 11.0879L3.42857 12.5802L4.874 12.1599Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Pen;
